import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import pThrottle from 'p-throttle';
import { addKillData, CharacterStatus, setActive, setCharactersStatus } from '../../Slices/uniqueKillsDataSlice';

const getUrl = (characterId: number, page = 1) =>
    `https://zkillboard.com/api/kills/characterID/${characterId}/page/${page}/`;

const getKills = (url: string) => {
    return axios.get(url).then(response => response.data);
};

const config = { limit: 1, interval: 1350 };
console.log('Starting queue with ', config);

const uniqueKillsQueue = pThrottle(config);

const useUniqueKillQueue = () => {
    const dispatch = useDispatch();
    const { characters, charactersStatus, active: queueActive } = useSelector((state: any) => state.uniqueKillsData);

    // console.log('==============');
    // console.log('characters', characters);
    // console.log('charactersStatus', charactersStatus);
    // console.log('==============');

    const checkQueue = (characters, charactersStatus) => {
        console.warn('----------------------------------------------------');

        const fetchTask = uniqueKillsQueue((characterId: number, characterStatus: CharacterStatus) => {
            console.log('Check', characterStatus);
            if (!characterStatus) return;

            const url = getUrl(characterId, characterStatus.current);
            console.log(` > Fetching ${url}`);

            return getKills(url).then(data => {
                dispatch(
                    addKillData({
                        characterId,
                        kills: data
                    })
                );
            });
        });

        const apiCalls: Promise<any>[] = [];
        Object.keys(characters).forEach(characterName => {
            const characterId = characters[characterName];
            const { active, current } = charactersStatus[characterId] || {};

            console.log('charactersStatus', characterId, charactersStatus[characterId]);

            if (current === 0) return;

            let promise;
            if (!charactersStatus[characterId]) {
                console.log(' => Initial', characterId);

                // Add initial item to the list
                const status = {
                    current: 1,
                    active: 1
                };
                dispatch(
                    setCharactersStatus({
                        characterId,
                        status
                    })
                );

                promise = fetchTask(characterId, status);
            } else {
                console.log(' => Next', characterId);

                if (current === active) return;
                if (!active) return;

                const newStatus = {
                    ...charactersStatus[characterId],
                    active: charactersStatus[characterId].current
                };

                dispatch(
                    setCharactersStatus({
                        characterId,
                        status: newStatus
                    })
                );

                promise = fetchTask(characterId, newStatus);
            }

            apiCalls.push(promise);
        });

        if (apiCalls.length > 0) {
            Promise.all(apiCalls).catch(error => {
                console.error('ApiCalls errors', error);
                dispatch(setActive(false));
            });
        } else {
            let isStillActive = false;
            Object.keys(charactersStatus).forEach(characterId => {
                if (charactersStatus[characterId] && charactersStatus[characterId].active) {
                    isStillActive = true;
                }
            });

            if (!isStillActive) {
                dispatch(setActive(false));
            }
        }
    };

    useEffect(() => {
        let interval = setInterval(() => {
            if (queueActive) checkQueue(characters, charactersStatus);
        }, 750);

        return () => {
            clearInterval(interval);
        };
    }, [queueActive, characters, charactersStatus]);
};

export default useUniqueKillQueue;
